export default __webpack_public_path__ + "static/media/dermaheal7.31c565f2.jpg";